import { REDIRECT_COOKIE_PREFIX } from "@/const/links";

const REDIRECT_ATTEMPT_TTL_MS = 30_000;

export function getRedirectAttemptKey(linkId: string): string {
  return `${REDIRECT_COOKIE_PREFIX}${linkId}`;
}

/**
 * Check if a redirect was already attempted by reading a cookie or
 * sessionStorage flag. Both can throw SecurityError in restricted WebViews
 * (e.g. in-app browsers with cookies disabled), so we fall through silently.
 */
export function hasRedirectBeenAttempted(key: string): boolean {
  try {
    if (document.cookie.includes(`${key}=`)) return true;
  } catch (e) {
    console.warn("Cookie read blocked:", e);
  }
  try {
    const expiresAt = Number(sessionStorage.getItem(key));
    if (Number.isFinite(expiresAt) && expiresAt > Date.now()) return true;
    sessionStorage.removeItem(key);
  } catch (e) {
    console.warn("SessionStorage read blocked:", e);
  }
  return false;
}

/** Persist a redirect-attempted flag via cookie + sessionStorage fallback. */
export function markRedirectAttempted(key: string): void {
  try {
    document.cookie = `${key}=1; path=/; max-age=30; SameSite=Lax`;
  } catch (e) {
    console.warn("Cookie write blocked:", e);
  }
  try {
    sessionStorage.setItem(key, String(Date.now() + REDIRECT_ATTEMPT_TTL_MS));
  } catch (e) {
    console.warn("SessionStorage write blocked:", e);
  }
}
